import * as React from "react";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { Link, NavLink } from "react-router-dom";
import { Container } from "@mui/material";
import logo from "../Assets/Images/logo.png";
// import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import MobileNav from "./MobileNav";

import CloseIcon from "@mui/icons-material/Close";

function Navbar(props) {
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const navLinkStyles = ({ isActive }) => {
    return {
      color: isActive ? "#782980" : "#782980",
      // padding: '0rem 0.8rem',
      borderRadius: "8px",
      display: "flex",
      transition: "0.5s",
      fontFamily: "centuryGothic",
      textDecoration: "none",
      alignItems: "center",
      // fontWeight: isActive ? '700' : '500',
    };
  };

  const drawer = <MobileNav handleDrawerToggle={toggleDrawer} cartValue={0} />;

  return (
    <Box>
      <CssBaseline />
      <AppBar
        component="nav"
        sx={{
          // position: "inherit",
          backgroundColor: "transparent",
          zIndex: 2000,
          // width: "100%",
          // backdropFilter: "blur(15px)",
          // background: "rgb(240 237 246 / 20%) !important",
          position: "relative",
          top: 0,
          boxShadow: "none",
          py: "1px",
          pr: "0 !important",
          //   borderBottom: { md: "none", lg: "1px solid #782980" },
        }}
      >
        <Container>
          <Toolbar
            sx={{
              justifyContent: "space-between",
              alignItems: { md: "flex-end" },
              py: "1.2rem",
              px: "0 !important",
              position: { lg: "relative" },
            }}
          >
            <Link to={"/"} style={{ lineHeight: "0" }}>
              {" "}
              <Typography component={"img"} src={logo} width={"260px"} />
            </Link>
            <IconButton
              disableRipple
              color="inherit"
              aria-label="open drawer"
              edge="start"
              // onClick={handleDrawerToggle}
              onClick={
                state?.top
                  ? toggleDrawer("top", false)
                  : toggleDrawer("top", true)
              }
              sx={{
                display: { lg: "none", color: "#014687" },
                p: "0",
                animation: "0.8s all",
              }}
            >
              {state?.top ? (
                <CloseIcon sx={{ animation: "0.8s all" }} />
              ) : (
                <MenuIcon sx={{ animation: "0.8s all" }} />
              )}
            </IconButton>

            <Box
              sx={{
                display: { md: "none", lg: "flex", sm: "none", xs: "none" },
                gap: "2rem",
                "& p":{
                  borderRadius: "8px",
                    cursor: "pointer",
                    fontSize: "19px",
                    fontFamily: "centuryGothic !important",
                    color: "#014687",
                    position: "relative",
                }
              }}
            >
              <NavLink style={navLinkStyles} to={"/"}>
                <Typography>
                  Home
                </Typography>
              </NavLink>
              <NavLink style={navLinkStyles} to={"/service/individual"}>
                <Typography>Individual Services</Typography>
              </NavLink>
              <NavLink style={navLinkStyles} to={"/service/provider"}>
                <Typography>Provider Services</Typography>
              </NavLink>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      <nav>
        {/* <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { md: "block", lg: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              background: "#e4dbe7",
              padding: "1rem",
            },
          }}
        >
          {drawer}
        </Drawer> */}
        <Drawer
          anchor={"top"}
          open={state["top"]}
          onClose={toggleDrawer("top", false)}
          sx={{
            background: "rgb(255 255 255 /10%)",
            backdropFilter: "blur(10px)",
            "& .MuiBackdrop-root": {
              background: "rgb(255 255 255 /30%)",
              backdropFilter: "blur(10px)",
            },
            "& .MuiDrawer-paper": {
              background: "rgb(255 255 255 /30%)",
              // backdropFilter:"blur(10px)",
              boxShadow: "none",
              transition: "transform 0.8s all",
            },
          }}
        >
          <Box
            sx={{ width: "100%", p: "0 1rem 1rem" }}
            role="presentation"
            // onClick={toggleDrawer("top", false)}
            // onKeyDown={toggleDrawer("top", false)}
          >
            {drawer}
          </Box>
        </Drawer>
      </nav>

      {/* ***subscribe modal**** */}
      {/* <Subscribe
        subscribeModal={subscribeModal}
        setSubscribeModal={setSubscribeModal}
      /> */}
    </Box>
  );
}

Navbar.propTypes = {
  window: PropTypes.func,
};

export default Navbar;
